import React from 'react';
import { Box, Typography } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import WarningIcon from '@mui/icons-material/Warning';
import ErrorIcon from '@mui/icons-material/Error';

const STATUS_CONFIG = {
  'Operational': {
    icon: CheckCircleIcon,
    color: '#4caf50',
    label: 'Operacional',
  },
  'In Progress': {
    icon: WarningIcon,
    color: '#ff9800',
    label: 'Em Progresso',
  },
  'Attention Required': {
    icon: ErrorIcon,
    color: '#f44336',
    label: 'Requer Atenção',
  },
};

/**
 * StatusIndicator - Displays status with icon and optional label
 * @param {string} status - Status (Operational, In Progress, Attention Required)
 * @param {boolean} showLabel - Whether to show the text label
 */
export const StatusIndicator = ({ status, showLabel = true }) => {
  const config = STATUS_CONFIG[status] || STATUS_CONFIG['In Progress'];
  const Icon = config.icon;

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
      <Icon sx={{ color: config.color, fontSize: 20 }} />
      {showLabel && (
        <Typography variant="body2" color="text.secondary">
          {config.label}
        </Typography>
      )}
    </Box>
  );
};
